import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { NamedLink } from '../../../components';

import blogs from '../blogs.json';
import css from './BlogsLandingPage.module.css';

import LayoutComposer from '../../../components/LayoutComposer/LayoutComposer';
import TopbarContainer from '../../TopbarContainer/TopbarContainer';
import FooterContainer from '../../FooterContainer/FooterContainer';
import CommunityComponent from '../../../components/CommunityComponent/CommunityComponent';

import { FaArrowUp } from 'react-icons/fa';

const categories = ['All', 'Healthcare', 'Cleaning', 'Grooming', 'Nutrition', 'Pet Care'];

const BlogsLandingPage = () => {
  const layoutAreas = `
    topbar
    main
    footer
  `;
  const currentPage = 'BlogsLandingPage';

  const [showScroll, setShowScroll] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('All');

  const handleScroll = () => {
    if (window.scrollY > 200) {
      setShowScroll(true);
    } else {
      setShowScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const filteredBlogs =
    selectedCategory === 'All' ? blogs : blogs.filter(blog => blog.category === selectedCategory);

  const latestPosts = blogs.slice(0, 4);

  return (
    <LayoutComposer areas={layoutAreas} className={css.layout}>
      {props => {
        const { Topbar, Main, Footer } = props;

        const getBlogLinkProps = blog => {
          // CMS pages start with /p
          if (blog.cmspage) {
            return {
              name: 'CMSPage',
              params: { pageId: blog.slug },
            };
          }

          // Normal blog
          return {};
        };


        return (
          <>
            <Helmet>
              <title>Blogs | Purfurry</title>
              <meta
                name="description"
                content="Read our latest blogs about pet care, boarding tips, grooming advice and more."
              />
              <meta name="keywords" content="boarding for dogs, dog boarding, pet grooming dog, pet care near me, dog grooming, boarding for puppies near me, pet groomers, boarding near me dogs, pets day care near me, pet boarding" />
            </Helmet>

            <Topbar as="header" className={css.topbar}>
              <TopbarContainer currentPage={currentPage} />
            </Topbar>

            <Main as="main" className={css.main}>
              {/* <div className={css.bannerContainer}>
                <img
                  src="/static/blogs/banner.jpg"
                  alt="Purfurry Blogs Banner"
                  className={css.bannerImage}
                />
                <div className={css.bannerOverlay}>
                  <h1 className={css.bannerTitle}>Discover Expert Pet Tips & Guides</h1>
                </div>
              </div> */}
              <div className={css.sectionWrapper}>
                {/* Filter */}
                <h1 className={css.bannerTitle}>Discover Expert Pet Tips & Guides</h1>

                <div className={css.filterBar}>
                  {categories.map(category => (
                    <button
                      key={category}
                      className={`${css.filterButton} ${selectedCategory === category ? css.active : ''
                        }`}
                      onClick={() => setSelectedCategory(category)}
                    >
                      {category}
                    </button>
                  ))}
                </div>
                {/* Grid */}
                <div className={css.contentGrid}>
                  {/* Left: Main Blogs */}
                  <div className={css.blogGrid}>
                    {filteredBlogs.map(blog => {
                      const linkProps = getBlogLinkProps(blog);
                      return (
                        <NamedLink
                          key={blog.slug}
                          {...linkProps}
                          className={css.blogCard}
                        // CMS PAGES ACCEPT PAGEID, NOT SLUG, SO CHANGE THE KEY TOO.
                        // VALUE WOULD BE SAME, BLOG.SLUG GIVE THAT THE SLUG HAS /P/SLUG IN BLOGS.JSON
                        >
                          <img
                            src={blog.coverImage}
                            alt={blog.title}
                            className={css.blogImage}
                            loading="lazy"
                          />
                          <div className={css.blogContent}>
                            <h2 className={css.blogTitle}>{blog.title}</h2>
                            <p className={css.blogMeta}>
                              By {blog.author}
                              <br />
                              {blog.date}
                            </p>

                          </div>
                        </NamedLink>
                      )
                    })}
                  </div>

                  {/* Right: Latest Posts */}
                  <div className={css.latestPosts}>
                    <h3>Latest Posts</h3>
                    {latestPosts.map(post => {
                      const linkProps = getBlogLinkProps(post);
                      return (
                        <NamedLink
                          key={post.slug}
                          {...linkProps}
                          className={css.latestPostCard}
                        >
                          <img
                            src={post.coverImage}
                            alt={post.title}
                            className={css.latestPostImage}
                            loading="lazy"
                          />
                          <div className={css.latestPostContent}>
                            <span className={css.categoryBadge}>{post.category}</span>
                            <p className={css.latestPostTitle}>{post.title}</p>
                          </div>
                        </NamedLink>
                      )
                    })}
                  </div>
                </div>
              </div>
            </Main>

            <Footer className={css.footer}>
              <CommunityComponent />
              <FooterContainer />
            </Footer>

              {showScroll && (
                <button className={css.scrollToTop} onClick={scrollToTop} aria-label="Scroll to top">
                  <FaArrowUp />
                </button>
              )}
              <a className={css.whatsappIcon} href='https://wa.me/918459591563?text=Hi%2C%20I%20am%20looking%20to%20speak%20with%20a%20Purf%20Expert.' target="_blank" aria-label="Scroll to top">
                <img src="/static/icons/whatsapp.png" alt="WhatsApp Icon" />
              </a>
          </>
        );
      }}
    </LayoutComposer>
  );
};

export default BlogsLandingPage;
